if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      if (this.cbmHeaderReady) return;
      this.cbmHeaderReady = true;
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            if (!e.cbmOverlayHandled && !document.querySelector('.side-panel.active') &&
                (this.toggle.classList.contains('active') || this.cbmOpenTimer)) {
              e.cbmOverlayHandled = true;
              this.closeMenu();
              e.preventDefault();
            }
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          this.closeMenu();
        } else {
          e.preventDefault();
          clearTimeout(this.toggle.cbmCloseTimer);
          this.toggle.setAttribute('open', '');
          document.body.classList.add('overflow-hidden');
          this.cbmOpenTimer = setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    closeMenu() {
      if (!this.toggle.classList.contains('active') && !this.toggle.hasAttribute('open')) return;
      clearTimeout(this.cbmOpenTimer);
      this.cbmOpenTimer = null;
      this.toggle.classList.remove('active');
      this.menu.querySelectorAll('details').forEach(details => {
        clearTimeout(details.cbmCloseTimer);
        details.removeAttribute('open');
        details.classList.remove('menu-opening', 'submenu-open');
      });
      document.body.classList.toggle('overflow-hidden', Boolean(document.querySelector('.side-panel.active')));
      this.closeAnimation(this.toggle);
      this.toggle.querySelector('.mobile-toggle').focus({ preventScroll: true });
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      clearTimeout(detailsElement.cbmCloseTimer);
      setTimeout(() => {
        if (!this.toggle.classList.contains('active') || !detailsElement.hasAttribute('open')) return;
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening', 'submenu-open');
      this.closeAnimation(detailsElement);
      detailsElement.querySelector('summary')?.focus({ preventScroll: true });
    }
    closeAnimation(detailsElement) {
      clearTimeout(detailsElement.cbmCloseTimer);
      detailsElement.cbmCloseTimer = setTimeout(() => detailsElement.removeAttribute('open'), 400);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      const scheduleResize = () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.resizeSubMenus());
      };
      window.addEventListener('resize', scheduleResize, options);
      window.addEventListener('scroll', () => {
        if (this.matches(':hover, :focus-within')) scheduleResize();
      }, { ...options, passive: true });
      this.submenus.forEach(submenu => {
        const item = submenu.parentElement;
        const open = () => {
          item.classList.remove('cbm-menu-closed');
          this.resizeSubMenus();
        };
        item.addEventListener('pointerenter', open, options);
        item.addEventListener('focusin', open, options);
        item.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          item.querySelector(':scope > a').focus({ preventScroll: true });
          item.classList.add('cbm-menu-closed');
          event.preventDefault();
        }, options);
      });
      this.resizeSubMenus();
      document.fonts.ready.then(() => {
        if (this.isConnected) scheduleResize();
      });
    }
    disconnectedCallback() {
      this.listeners?.abort();
      cancelAnimationFrame(this.resizeFrame);
    }
    resizeSubMenus() {
      if (!this.offsetWidth) return;
      const width = document.documentElement.clientWidth;
      const height = window.innerHeight;
      this.submenus.forEach((submenu) => {
        submenu.style.left = '';
        const rootRect = submenu.getBoundingClientRect();
        const shift = Math.max(8 - rootRect.left, Math.min(0, width - 8 - rootRect.right));
        if (shift) submenu.style.left = `${parseFloat(getComputedStyle(submenu).left) + shift}px`;
        const nested = submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu');
        nested.forEach(child => {
          const item = child.parentElement;
          item.classList.remove('left-submenu');
          const rect = child.getBoundingClientRect();
          const itemRect = item.getBoundingClientRect();
          if (rect.right > width - 8 && itemRect.left - 26 > width - itemRect.right - 26) {
            item.classList.add('left-submenu');
          }
        });
        [submenu, ...nested].forEach(menu => {
          const leaf = !menu.querySelector('.sub-menu');
          menu.classList.toggle('cbm-menu-leaf', leaf);
          if (!leaf) return;
          menu.style.top = '';
          let top = menu.getBoundingClientRect().top;
          if (top < 8) {
            menu.style.top = `${parseFloat(getComputedStyle(menu).top) + 8 - top}px`;
            top = 8;
          }
          menu.style.setProperty('--cbm-menu-height', `${Math.max(48, height - top - 16)}px`);
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
